import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initializeGoogleAdsTag } from './utils/googleAds';
import { initializeMetaPixel } from './utils/metaPixel';
import { initializeAppIcons } from './utils/appIcons';
initializeAppIcons();
initializeGoogleAdsTag();
initializeMetaPixel();
render(<ErrorBoundary data-id="element-2353" data-mp="2a9uktpq78nw7">
    <App data-id="element-2354" data-mp="2aacmx2zjlwc1" />
  </ErrorBoundary>, document.getElementById('root'));